// extracted by mini-css-extract-plugin
export var fadeIn = "_iw-1";
export var modalContent = "_iw-3";
export var overlay = "_iw-0";
export var popoverContent = "_iw-2";
export var results = "_iw-5";
export var searchInputWrapper = "_iw-4";